import { useState } from "react";
import type { FormEvent } from "react";

import { ApiError } from "./api";
import { useAuth } from "./auth";

/** Shown while the account must change its password; the API refuses everything else until then. */
export function ChangePasswordPage() {
  const { changePassword, logout } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [repeat, setRepeat] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (next !== repeat) {
      setError("The new passwords do not match.");
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await changePassword(current, next);
    } catch (caught) {
      setError(
        caught instanceof ApiError && typeof caught.detail === "string"
          ? `Password not changed: ${caught.detail}.`
          : "Password not changed. Try again.",
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login">
      <h1>Change your password</h1>
      <p>Your password was set by an administrator. Choose your own before continuing.</p>
      <form onSubmit={onSubmit} aria-label="Change password">
        <label>
          Current password
          <input type="password" autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} required />
        </label>
        <label>
          New password
          <input type="password" autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)} required />
        </label>
        <label>
          Repeat new password
          <input type="password" autoComplete="new-password" value={repeat} onChange={(e) => setRepeat(e.target.value)} required />
        </label>
        {error && <p role="alert">{error}</p>}
        <button type="submit" disabled={busy}>
          Change password
        </button>
        <button type="button" onClick={() => void logout()}>
          Sign out
        </button>
      </form>
    </main>
  );
}
